import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withStyles,
  Grid,
  Typography,
} from '@material-ui/core';

import TextFormat from '@material-ui/icons/TextFormat';
import PlusOne from '@material-ui/icons/PlusOne';
import DateRange from '@material-ui/icons/DateRange';
import Schedule from '@material-ui/icons/Schedule';
import Users from '@material-ui/icons/Group';

export const styles = () => ({
  container: { margin: 5 },
  cardCenter: { textAlign: 'center' },
  root: { flexGrow: 1 },
  typeContainer: { maxWidth: 200 },
  control: { padding: 4 },
});

export class EventDataInformationCardComponent extends React.Component {
  render() {
    return (
      <Grid container justify="center" className={this.props.classes.container}>
        <Grid item>
          <h3 className={this.props.classes.cardCenter}>
            <small>
              Custom Fields can be used to provide additional datapoints to the events you create and manage
            </small>
          </h3>
          <p className={this.props.classes.cardCenter}>
            Create any number of data fields, you can pick and choose which fields you want to use on each Event.
            By default, events have Name, Description, and Comment fields.
            These Custom Fields fields will let you track additional information that is relevant
            to your organization and events.
          </p>

          <h4>Name</h4>
          <div>
            <p>
              The name of the Custom Field Field is used
              as the label/display for the datapoint.
            </p>
            <br />
            <p>
              Create Custom Fields that will meet the need of the event.
              If you need to track dates, specific numbers, or just text,
              you can create a field for each.
            </p>
          </div>

          <h4>Data Types</h4>
          <div>
            <p>
              The type of the Custom Field determins the allowable input a
              user will provide. You can choose from any of the following types:
            </p>
            <br />
            <Grid container className={this.props.classes.root} spacing={3}>
              <Grid item xs={12}>
                <Grid container className={this.props.classes.demo} justify="center" spacing={3}>
                  <Grid key="text" item className={this.props.classes.typeContainer}>
                    <Typography variant="h6" gutterBottom align="center">
                      <TextFormat color="primary" />&nbsp;
                      Text
                    </Typography>
                    <Typography gutterBottom variant="caption">
                      Open text field. Users can provide any input here.
                    </Typography>
                  </Grid>
                  <Grid key="number" item className={this.props.classes.typeContainer}>
                    <Typography variant="h6" gutterBottom align="center">
                      <PlusOne color="primary" />&nbsp;
                      Number
                    </Typography>
                    <Typography gutterBottom variant="caption">
                      Numerical input field. Only numbers or decimal values can be provided.
                    </Typography>
                  </Grid>
                  <Grid key="date" item className={this.props.classes.typeContainer}>
                    <Typography variant="h6" gutterBottom align="center">
                      <DateRange color="primary" />&nbsp;
                      Date
                    </Typography>
                    <Typography gutterBottom variant="caption">
                      Date field. Only specific dates can be provided.
                      A date picker can be used for easy selection.
                    </Typography>
                  </Grid>
                  <Grid key="datetime" item className={this.props.classes.typeContainer}>
                    <Typography variant="h6" gutterBottom align="center">
                      <Schedule color="primary" />&nbsp;
                      Datetime
                    </Typography>
                    <Typography gutterBottom variant="caption">
                      Date and Time field. A date and specific time can be provide.
                      A date and time picker can be used for easy selection.
                    </Typography>
                  </Grid>
                  <Grid key="datetime" item className={this.props.classes.typeContainer}>
                    <Typography variant="h6" gutterBottom align="center">
                      <Users color="primary" />&nbsp;
                      User
                    </Typography>
                    <Typography gutterBottom variant="caption">
                      User field. A field that allows you to select one or
                      many users.
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>

          <h4>Archiving</h4>
          <div>
            <p>
              You can archive Custom Fields at any time. Archiving
              does not remove the field perminately, but instead will hide it from
              being used in new Workflows or Events.
              You can always un-archive an Custom Field.
            </p>
            <br />
            <p>
              <b>Note</b> that Events and Workflows
              already created with an archived field will still be able to utilize/view
              it. If you wish to remove an Custom Field from being used again you must
              remove it from all Workflows which already had it assigned. Previous
              Events created with the field will still show and retain the data of that
              field.
            </p>
          </div>
        </Grid>
      </Grid>
    );
  }
}

EventDataInformationCardComponent.propTypes = { classes: PropTypes.object.isRequired };

export default
connect()(withStyles(styles, { withTheme: true })(EventDataInformationCardComponent));
